// ForgotPassword.jsx
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import AuthLayout from "./authLayout";
import { motion } from "framer-motion";
import apiClient from "../api/config";
import { ROUTES } from "../routes";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);
    try {
      await apiClient.post("/api/forgot-password/", { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || "Unable to send reset link. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Forgot password?" subtitle="Enter your email and we'll send you a reset link">
      {submitted ? (
        <div className="text-center">
          <p style={{ color: "var(--color-text)", fontSize: 14, marginBottom: 20 }}>
            If an account exists for <strong>{email}</strong>, we've sent a link to reset your password.
          </p>
          <Link to={ROUTES.LOGIN} className="auth-link" style={{ fontSize: 14 }}>
            Back to sign in
          </Link>
        </div>
      ) : (
        <Form onSubmit={handleSubmit}>
          {error && (
            <motion.div
              initial={{ opacity: 0, y: -6 }}
              animate={{ opacity: 1, y: 0 }}
              className="mb-3"
              style={{
                background: "rgba(239,68,68,0.12)",
                color: "#ef4444",
                padding: "10px 14px",
                borderRadius: 10,
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              {error}
            </motion.div>
          )}

          <Form.Group className="mb-4">
            <Form.Label style={{ color: "var(--color-text-light)" }}>Email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              placeholder="Enter your email"
              onChange={(e) => setEmail(e.target.value)}
              className="auth-input"
              style={{ background: "var(--color-bg)", color: "var(--color-text)" }}
            />
          </Form.Group>

          <motion.button
            whileHover={{ scale: !loading ? 1.02 : 1 }}
            whileTap={{ scale: !loading ? 0.98 : 1 }}
            type="submit"
            className="w-100"
            disabled={loading}
            style={{
              background: "#6f42c1",
              border: "none",
              borderRadius: 12,
              padding: "10px 0",
              color: "#fff",
              fontWeight: 600,
              fontSize: 15,
              marginBottom: "1rem",
              opacity: loading ? 0.8 : 1,
              transition: "0.2s",
            }}
          >
            {loading ? "Sending..." : "Send reset link"}
          </motion.button>

          <div className="text-center">
            <Link to={ROUTES.LOGIN} className="auth-link" style={{ fontSize: 14 }}>
              Back to sign in
            </Link>
          </div>
        </Form>
      )}
    </AuthLayout>
  );
}
